import React from 'react';

import { Filter, SearchHead, FilterDetail, FilterDetails } from './styles';
import PropTypes from 'prop-types';

function generateFilters(filters, clicked) {
  const resultantFilter = filters.map((type, index) => (
    <FilterDetail
      data-test="filter-detail"
      cursorhandle={true}
      active={type.popup ? true : false}
      key={type.type}
      onClick={() => clicked(index)}
    >
      <span>{type.type}</span>
      {type.applicable ? (
        <span>
          {type.type === 'Balance' ||
          type.type === 'Year Opened' ||
          type.type === 'Designated Role'
            ? 1
            : type.selectedVal.length}
        </span>
      ) : (
        <span>0</span>
      )}
    </FilterDetail>
  ));
  return resultantFilter;
}

const FilterWeb = ({ filters, clicked }) => {
  const resultantFilter = generateFilters(filters, clicked);
  return (
    <Filter>
      <SearchHead>Filters</SearchHead>
      <div>
        <FilterDetails>{resultantFilter}</FilterDetails>
      </div>
    </Filter>
  );
};
FilterWeb.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  clicked: PropTypes.func,
};
export default FilterWeb;
